/**
 * Single place for Finnish reporting period (defaults to UTC calendar year).
 * Optional `Europe/Helsinki` can be wired later via `TAX_PIPELINE.fi.timezone`.
 */
export function taxYearUtc(tsMs: number): number {
  return new Date(tsMs).getUTCFullYear();
}
